let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("avCUM")).then(() => parcelRequire('6jcw2'));